// tslint:disable:no-var-requires

export const Aluxion = require("./files/aluxion.svg");
export const AluxionWhite = require("./files/aluxion-white.svg");
export const CalendarWhite = require("./files/calendar-white.svg");
export const moon = require("./files/moon.svg");
export const moonWhite = require("./files/moon-white.svg");
export const LoginWhite = require("./files/login-white.svg");
export const LoginBlack = require("./files/login-black.svg");
